

export default function FormButton({pending, name, onClick}) {
  return (
    <>
      {!pending && <button className='btn btn-secondary' style={{margin: '20px 20px 20px 0'}} onClick={onClick}>{name}</button>}
      {pending && <button className='btn btn-secondary' style={{margin: '20px 20px 20px 0'}} disabled>Submitting...
          <span className='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span>
      </button>}
    </>
  )
}